import { useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { EditorStatus } from '../../DocumentOverview/Context';
import {
  APICancelledError,
  TrainingAsessmentAPI,
} from '../api/trainingAssessmentApi';
import { TrainingAssessment } from '../types/trainingAssessment';

export const useDeleteTrainingAssessment = (
  documentId: TrainingAssessment['document_id'],
  setTrainingAssessmentStatus: (status: EditorStatus) => void,
) => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      TrainingAsessmentAPI.deleteTrainingAssessmentForDocument(documentId),

    onMutate: async () => {
      setTrainingAssessmentStatus(EditorStatus.SAVING);
      await queryClient.cancelQueries(['trainingAssessment', documentId]);
    },

    onError: (error: any) => {
      if (error instanceof APICancelledError) {
        return;
      }

      setTrainingAssessmentStatus(EditorStatus.ERROR);

      showToast({
        'data-cy': 'use-delete-training-assessment-notify-error-toast',
        status: 'error',
        title: t('notifications.error'),
        description: t('notifications.failedToDeleteTrainingAssessment'),
      });
    },
    onSuccess: () => {
      setTrainingAssessmentStatus(EditorStatus.SAVED);
    },
    onSettled: async () =>
      await queryClient.invalidateQueries(['trainingAssessment', documentId]),
  });
};
